import * as React from "react"
import { LocalStorageItems } from "@modules/localStorage/constants"
import { SourceControlProvider } from "@modules/graphql/types"

function useSelectedProvider() {
  const [selectedProvider, setSelectedProvider] = React.useState<
    SourceControlProvider | undefined
  >(undefined)

  // initialize value from localStorage
  React.useEffect(() => {
    const persistedSelectedProvider = localStorage.getItem(
      LocalStorageItems.GatsbySelectedProvider
    )
    if (persistedSelectedProvider) {
      setSelectedProvider(persistedSelectedProvider as SourceControlProvider)
    }
  }, [])

  // persist selectedProvider when it changes
  React.useEffect(() => {
    localStorage.setItem(
      LocalStorageItems.GatsbySelectedProvider,
      selectedProvider || ""
    )
  }, [selectedProvider])

  return [selectedProvider, setSelectedProvider] as const
}

export default useSelectedProvider
